import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';

export type TransferStoreTypeParam = 'MAIN_STORE' | 'KITCHEN_STORE';

export type TransferStoreTypeOption = {
  id: 'MAIN_STORE' | 'KITCHEN_STORE';
  name: string;
};

export const DEFAULT_TRANSFER_STORE_TYPE: TransferStoreTypeParam = 'MAIN_STORE';

export const TRANSFER_STORE_TYPE_OPTIONS: Record<TransferStoreTypeParam, TransferStoreTypeOption> =
  {
    MAIN_STORE: { id: 'MAIN_STORE', name: 'Main store' },
    KITCHEN_STORE: { id: 'KITCHEN_STORE', name: 'Kitchen store' }
  };

export const TRANSFER_BASE_ROUTE_MAP: Record<TransferStoreTypeParam, string> = {
  MAIN_STORE: MAIN_STORE_ROUTE_KEYS.TRANSFER,
  KITCHEN_STORE: MAIN_STORE_ROUTE_KEYS.KITCHEN_TRANSFER
};

export const normalizeTransferStoreType = (
  value: string | null | undefined,
  fallback: TransferStoreTypeParam = DEFAULT_TRANSFER_STORE_TYPE
): TransferStoreTypeParam => {
  if (value === 'MAIN_STORE' || value === 'KITCHEN_STORE') {
    return value;
  }
  return fallback;
};

export const getTransferStoreTypeFromPathname = (pathname: string): TransferStoreTypeParam => {
  if (pathname.startsWith(MAIN_STORE_ROUTE_KEYS.KITCHEN_TRANSFER)) {
    return 'KITCHEN_STORE';
  }
  return 'MAIN_STORE';
};

export const buildTransferRoute = (storeType: TransferStoreTypeParam, suffix?: string) => {
  const basePath = TRANSFER_BASE_ROUTE_MAP[storeType];
  if (!suffix) {
    return basePath;
  }
  return `${basePath}/${suffix}`;
};
